import React from 'react'

export function folder() {
  return (
    <svg viewBox="0 0 20 22" style={{enableBackground:"new 0 0 20 22"}} fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 19V3C0 2.44772 0.447715 2 1 2H7.38197C7.76074 2 8.107 2.214 8.27639 2.55279L9.22361 4.44721C9.393 4.786 9.73926 5 10.118 5H19C19.5523 5 20 5.44772 20 6V19C20 19.5523 19.5523 20 19 20H1C0.447715 20 0 19.5523 0 19Z" fill="#22577D"/>
    </svg>
  )
}
